export default "__VITE_ASSET__DPBuqG0c__"